import moment from 'moment-timezone'
import Vue2Filters from 'vue2-filters'

const number = v => (v || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const date = (value, opt = 'YYYY.MM.DD') => (value != '0001-01-01T00:00:00' && value && moment(value).format(opt) || '-');
const datetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value != '0001-01-01T00:00:00' && value && moment(value).format(opt) || '-');
const sdate = (value) => value && moment(value).format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';
const dollar = (v) => { return v ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'})).format(v) : '-' }


var Filter = {
  install: function(Vue) {
    Vue.use(Vue2Filters);

    Vue.filter('number', number);
    Vue.filter('date', date);
    Vue.filter('datetime', datetime);
    Vue.filter('sdate', sdate);
    Vue.filter('dollar', dollar);
  }
}

export default Filter;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Filter);
}
